<script>
export default {
  name: 'Jumping'
}
</script>

<template>
  <div class="jumping">
    <div class="jumping-item first-item"></div>
    <div class="jumping-item second-item"></div>
    <div class="jumping-item third-item"></div>
  </div>
</template>

<style lang="scss" scoped>
.jumping {
  width: 20px;
  height: 23px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  .jumping-item {
    width: 5px;
    background-color: #E8372A;
    border-radius: 8px;
  }
  .first-item {
    height: 18px;
    animation: first-jumping linear .8s infinite;
  }
  .second-item {
    height: 23px;
    animation: second-jumping linear .6s infinite;
  }
  .third-item {
    height: 16px;
    animation: third-jumping linear .8s infinite;
  }
}

@keyframes first-jumping {
  0% {height: 23px;}
  50% {height: 2px;}
  100% {height: 18px;}
}
@keyframes second-jumping {
  0% {height: 23px;}
  50% {height: 2px;}
  100% {height: 23px;}
}
@keyframes third-jumping {
  0% {height: 16px;}
  50% {height: 8px;}
  100% {height: 16px;}
}
</style>
